module.exports = __webpack_public_path__ + "media/images/icons/couple-e7de32a2d01652f936160556f04415e5.png";